import React, { useContext, useState } from "react";
import { AppContext } from "../../../../Context/Context";
import { useHistory } from "react-router-dom";

export const Notificacion = ({
    id,
    fecha,
    link,
    textoLink,
    mensaje,
    titulo,
    onDelete
}) => {
    const [state, setState] = useContext(AppContext);
    const history = useHistory();

    const [isDeleting, setDeleting] = useState(false);

    const handleDeleteNotification = async () => {
        const documento = atob(sessionStorage.getItem("dtdc"));
        setDeleting(true);

        try {
            const endpoint = await (await fetch('/api/show_endpoints/wsbajanotificacion')).json();
            await fetch(`${endpoint.url_base}${endpoint.url_variable}?CUIT=${documento}&SecuenciaNotificacion=${id}`, {
                cache: 'no-cache',
            });

            // Immediately remove from UI
            onDelete(id);
        } catch (error) {
            console.error("Error deleting notification:", error);
        } finally {
            setDeleting(false);
        }
    };


    return (
        <div
            id="notificacion"
            className="notificaciones_mainDiv_notificacion--wrapper"
        >
            <div className="notificaciones_mainDiv_notificacion">
                <div>
                    <div className="notificaciones_mainDiv_notificacion--date">
                        <p>{fecha}</p>
                    </div>
                    <div className="notificaciones_mainDiv_notificacion--title">
                        <p className="circle">{titulo}</p>
                    </div>
                    <div className="notificaciones_mainDiv_notificacion--descripcion">
                        <p>{mensaje}</p>
                    </div>
                    {link.length !== 0 && (
                        <a
                            href={link}
                            className="notificaciones_mainDiv_notificacion--link"
                        >
                            {textoLink.length !== 0
                                ? textoLink
                                : "Acceda al link"}
                        </a>
                    )}
                </div>
                <div
                    className="notificaciones_mainDiv_notificacion--tachito m-auto"
                    onClick={handleDeleteNotification}
                >
                    {isDeleting ? (
                        <div className="spinner-loader w-100 h-100 d-flex justify-content-center">
                            <div
                                className="spinner-border text-bordo align-self-center"
                                role="status"
                            >
                            </div>
                        </div>
                    ) : (
                        <img src="/images/icons/tachito.svg" />
                    )}
                </div>
            </div>
            <div className="separator--hor separatorPersonalizado mt-base"></div>
        </div>
    );
};
